import React, { useContext } from "react";
import Form from "react-bootstrap/Form";
import { QuizContext } from "../../App";

const FormTeamSetTypeAddMemb = () => {

  const quizContext = useContext(QuizContext);

  return (
    <div key={"inline-radio"} className="mb-3">

      {quizContext.state.radioValues.map((el, i) =>
        <Form.Check
          inline
          label={el.labelRU}
          key={i}
          name="team member"
          type="radio"
          checked={
            quizContext.state.typeAddMemb === el.value
              ? true : false}
          value={el.value}
          id={i + 1}
          onChange={(e) => quizContext.dispatch({
            type: "setTypeAddMemb",
            payload: e.target.value
          })}
        />
      )}
    </div>
  )
}

export default FormTeamSetTypeAddMemb